/**

 * Fattah UI design tokens — single brand + neutral scale + semantic colors.

 * @see docs/design/UI_QUALITY_SCORECARD.md

 */



export const FATTAH_TOKENS = {

  sidebar: {

    widthExpanded: '16.25rem', // 260px

    widthCollapsed: '4.5rem', // 72px

    headerHeight: '3.25rem',

  },

  header: {

    height: '3.25rem',

  },

  /** 4px base scale — use Tailwind spacing utilities aligned to this */

  spacing: {

    page: '1.5rem', // p-6 — main content padding

    section: '1.5rem', // space-y-6 between sections

    card: '1.25rem', // p-5 — card inner padding

    stack: '1rem', // gap-4 — grid/flex gaps

    tight: '0.75rem', // gap-3

  },

  typography: {

    pageTitle: 'text-xl font-semibold tracking-tight',

    pageDescription: 'text-sm text-slate-500 dark:text-slate-400',

    sectionTitle: 'text-sm font-semibold text-slate-900 dark:text-slate-100',

    sectionDescription: 'text-sm text-slate-500 dark:text-slate-400',

    kpiValue: 'text-2xl font-semibold tabular-nums tracking-tight',

    kpiLabel: 'text-sm font-medium text-slate-500 dark:text-slate-400',

    tableHeader: 'text-xs font-semibold uppercase tracking-wide text-slate-500',

  },

  radius: {

    control: 'rounded-lg',

    card: 'rounded-xl',

  },

  motion: {

    fast: '150ms',

    normal: '200ms',

  },

  zIndex: {

    dropdown: 40,

    modal: 50,

    commandPalette: 60,

  },

  semantic: {

    success: { bg: 'bg-emerald-50 dark:bg-emerald-950/40', text: 'text-emerald-700 dark:text-emerald-300', border: 'border-emerald-200 dark:border-emerald-800' },

    warning: { bg: 'bg-amber-50 dark:bg-amber-950/40', text: 'text-amber-800 dark:text-amber-300', border: 'border-amber-200 dark:border-amber-800' },

    error: { bg: 'bg-red-50 dark:bg-red-950/40', text: 'text-red-700 dark:text-red-300', border: 'border-red-200 dark:border-red-800' },

    info: { bg: 'bg-slate-50 dark:bg-slate-900/50', text: 'text-slate-700 dark:text-slate-300', border: 'border-slate-200 dark:border-slate-700' },

  },

} as const;



export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';

export type ButtonSize = 'sm' | 'md' | 'lg';



/** Size modifiers — base padding lives on `.btn` in index.css */
export const BUTTON_SIZE: Record<ButtonSize, string> = {
  sm: 'btn-sm',
  md: '',
  lg: 'btn-lg',
};



export type TableDensity = 'comfortable' | 'compact';



export const TABLE_CELL_PADDING: Record<TableDensity, { th: string; td: string }> = {

  comfortable: { th: 'px-4 py-3', td: 'px-4 py-3' },

  compact: { th: 'px-3 py-2', td: 'px-3 py-2' },

};


